// extracted by mini-css-extract-plugin
export default {"sources-info":"styles_sources-info__PmIbA","counter":"styles_counter__azaHQ","number":"styles_number__zm3dT","slideUp":"styles_slideUp__ey+H8"};